import { render } from "./CommentList.vue?vue&type=template&id=76aaaa6a"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"

import "./CommentList.vue?vue&type=style&index=0&id=76aaaa6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__